<div class="container personas">
  <h1 class="titulo-terminos" *ngIf="!param && languaje === 'en'">Terms and Conditions</h1>
  <p class="description" *ngIf="!param && languaje === 'en'">The general information and content in <strong>Section A</strong> is related to the management of the program and/or points, <strong>Scotiabank's</strong> sole responsibility. For more information or to resolve doubts related to <strong>Section A</strong>, please contact the Bank through the following channels:</p>
  <h1 class="titulo-terminos" *ngIf="!param && languaje === 'es'">Términos y Condiciones</h1>
  <p class="description" *ngIf="!param && languaje === 'es'">La informaci&oacute;n y contenido general de la <strong>Secci&oacute;n A</strong> est&aacute; relacionada con el manejo del programa y/o puntos, responsabilidad exclusiva de <strong>Scotiabank</strong>. Para obtener mayor informaci&oacute;n o resolver dudas en relaci&oacute;n a la <strong>Secci&oacute;n A</strong>, por favor p&oacute;ngase en contacto con el <strong>Banco</strong> a trav&eacute;s de los siguientes canales:</p>
  <div class="contenedor-pestanas" [style.margin]="param ? '0' : '20px 0'">
    <div class="row tab-v3">
      <div class="col-12 col-lg-3 pestanas">
        <ul class="nav nav-pills nav-stacked">
          <app-miles-use (x)="resetFlags(); tabs_state.use = true"
            [is_active]="tabs_state.use" style="width: 100%"></app-miles-use>

          <li class="section-tab" >
            <span *ngIf="languaje === 'en'">SECTION A</span>
            <span *ngIf="languaje === 'es'">SECCIÓN A</span>
          </li>

          <app-program-definition-scotia (x)="resetFlags(); tabs_state.glosary = true"
            [is_active]="tabs_state.glosary" style="width: 100%"></app-program-definition-scotia> 
          <!-- <app-scotia-rewards-fixed (x)="resetFlags(); tabs_state.upper_general = true" [is_active]="tabs_state.upper_general"
            style="width: 100%"></app-scotia-rewards-fixed> -->
            <app-scotia-rewards-enrollment (x)="resetFlags(); tabs_state.care_protection = true" [is_active]="tabs_state.care_protection"
            style="width: 100%"></app-scotia-rewards-enrollment>
          <app-scotia-rewards-communications (x)="resetFlags(); tabs_state.business_model = true" [is_active]="tabs_state.business_model"
            style="width: 100%"></app-scotia-rewards-communications>
            <app-privacy-notice-mr (x)="resetFlags(); tabs_state.privacy = true" [is_active]="tabs_state.privacy"
            style="width: 100%"></app-privacy-notice-mr>
          
          <li class="section-tab" >
            <span *ngIf="languaje === 'en'">SECTION B</span>
            <span *ngIf="languaje === 'es'">SECCIÓN B</span>
          </li>

          <app-website-scotia (x)="resetFlags(); tabs_state.stay_care = true" [is_active]="tabs_state.stay_care" style="width: 100%">
          </app-website-scotia>
          <app-general-conditions-scotia (x)="resetFlags(); tabs_state.fly_care = true"
            [is_active]="tabs_state.fly_care" style="width: 100%"></app-general-conditions-scotia>
            <app-flexway-scotia (x)="resetFlags(); tabs_state.flex = true"
            [is_active]="tabs_state.flex" style="width: 100%"></app-flexway-scotia>
            <app-stay-care-scotia (x)="resetFlags(); tabs_state.additional_protection = true" [is_active]="tabs_state.additional_protection"
            style="width: 100%"></app-stay-care-scotia> 
          <app-fly-care-scotia (x)="resetFlags(); tabs_state.exclusion_lm = true" [is_active]="tabs_state.exclusion_lm"
            style="width: 100%"></app-fly-care-scotia>
            <app-other-benefits-scotia (x)="resetFlags(); tabs_state.cyber_risk = true" [is_active]="tabs_state.cyber_risk" style="width: 100%">
            </app-other-benefits-scotia>
            <!-- <app-cyber-risk (x)="resetFlags(); tabs_state.cyber = true" [is_active]="tabs_state.cyber" style="width: 100%">
            </app-cyber-risk> -->
            <app-exclusions-scotia (x)="resetFlags(); tabs_state.coverage = true" [is_active]="tabs_state.coverage" style="width: 100%">
            </app-exclusions-scotia>
          <app-coverage-information-scotia (x)="resetFlags(); tabs_state.information = true" [is_active]="tabs_state.information"
            style="width: 100%"></app-coverage-information-scotia>
            <app-glosary-scotia (x)="resetFlags(); tabs_state.coverage_provisions = true"
            [is_active]="tabs_state.coverage_provisions" style="width: 100%"></app-glosary-scotia>
        </ul>
      </div>
      <div class="col-12 col-lg-9 contenido"> 
        <div class="tab-content">
          <app-miles-use [show_content]="tabs_state.use"></app-miles-use>
          
          <div class="section-tab" >
            <span *ngIf="languaje === 'en'">SECTION A</span> 
            <span *ngIf="languaje === 'es'">SECCIÓN A</span>
          </div>
          <app-program-definition-scotia [show_content]="tabs_state.glosary"></app-program-definition-scotia>
          <!-- <app-scotia-rewards-fixed [show_content]="tabs_state.upper_general">
          </app-scotia-rewards-fixed> -->
          <app-scotia-rewards-enrollment [show_content]="tabs_state.care_protection"></app-scotia-rewards-enrollment>
          <app-scotia-rewards-communications [show_content]="tabs_state.business_model"></app-scotia-rewards-communications>
          <app-privacy-notice-mr [show_content]="tabs_state.privacy"></app-privacy-notice-mr>
          <div class="section-tab" >
            <span *ngIf="languaje === 'en'">SECTION B</span>
            <span *ngIf="languaje === 'es'">SECCIÓN B</span>
          </div>
          <app-website-scotia [show_content]="tabs_state.stay_care"></app-website-scotia>
          <app-general-conditions-scotia [show_content]="tabs_state.fly_care"></app-general-conditions-scotia>
          <app-flexway-scotia [show_content]="tabs_state.flex"></app-flexway-scotia>
          <app-stay-care-scotia [show_content]="tabs_state.additional_protection"></app-stay-care-scotia>
          <app-fly-care-scotia [show_content]="tabs_state.exclusion_lm"></app-fly-care-scotia>
          <app-other-benefits-scotia [show_content]="tabs_state.cyber_risk"></app-other-benefits-scotia>
          <!-- <app-cyber-risk [show_content]="tabs_state.cyber"></app-cyber-risk> -->
          <app-exclusions-scotia [show_content]="tabs_state.coverage"></app-exclusions-scotia>
          <app-coverage-information-scotia [show_content]="tabs_state.information"></app-coverage-information-scotia>
          <app-glosary-scotia [show_content]="tabs_state.coverage_provisions"></app-glosary-scotia>
          
        </div>
      </div>
    </div>
  </div>
</div>

